module.exports = __webpack_public_path__ + "805a55928b346cbf6da234fe55a1d741.svg";


//////////////////
// WEBPACK FOOTER
// ./images/sent-icon.svg
// module id = 947
// module chunks = 0